import React, { useEffect } from "react";
import MainLayout from "../component/shared/layout/MainLayout";
import LadyComponent from "../component/shared/LadyComponent/LadyComponent";
import CertifiedComponent from "../component/shared/Certified/CertifiedComponent";
import FreeQuoteToday from "../component/shared/FreeQuote/FreeQuoteToday";
import RatingComponent from "../component/shared/RatingComponent.jsx/RatingComponent";
import ReviewsComponent from "../component/ReviewsComponent/Reviews";
import PageTopComponent from "../component/shared/PageTopComponet/PageTopComponent";
import { Review } from "../Services/Reviews";
import { useLocation } from "react-router-dom";

function Reviews() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div>
      <MainLayout>
        <PageTopComponent componentdata={Review} />
        <RatingComponent />
        <ReviewsComponent />
        <LadyComponent />
        <CertifiedComponent />
        <FreeQuoteToday />
      </MainLayout>
    </div>
  );
}

export default Reviews;
